import { render, staticRenderFns } from "./OuterPerkShopUpgradeButton.vue?vue&type=template&id=238296b6&scoped=true&"
import script from "./OuterPerkShopUpgradeButton.vue?vue&type=script&lang=js&"
export * from "./OuterPerkShopUpgradeButton.vue?vue&type=script&lang=js&"
import style0 from "./OuterPerkShopUpgradeButton.vue?vue&type=style&index=0&id=238296b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238296b6",
  null
  
)

export default component.exports